import type { UserPermission } from "@/services/auth/retrieveCurrentUser"

export const useRequiredPermissions = (
  requiredPermissions: MaybeRef<
    UserPermission | ReadonlyArray<UserPermission>
  >
) => {
  const { permissions } = useAuth()

  const requiredPermissionList = computed<
    ReadonlyArray<UserPermission>
  >(() => {
    const unreffedRequiredPermissions = unref(
      requiredPermissions
    )

    return Array.isArray(unreffedRequiredPermissions)
      ? unreffedRequiredPermissions
      : [unreffedRequiredPermissions]
  })

  const hasRequiredPermissions = computed(() =>
    requiredPermissionList.value.every((permission) =>
      permissions.value.includes(permission)
    )
  )

  return {
    hasRequiredPermissions,
  }
}
